/**
 * AGROMX Frontend - Toast Utility
 * Sistema de notificaciones toast
 */

class Toast {
  constructor() {
    this.container = document.getElementById('toast-container');
    this.duration = 3000; // 3 segundos por defecto
  }

  /**
   * Mostrar toast
   */
  show(message, type = 'info', duration = this.duration) {
    const toast = document.createElement('div');
    toast.className = `toast toast-${type}`;
    toast.innerHTML = `
      <div style="display: flex; align-items: start; gap: 0.75rem;">
        <div style="flex-shrink: 0;">
          ${this.getIcon(type)}
        </div>
        <div style="flex: 1;">
          <p style="font-weight: 600; margin-bottom: 0.25rem;">${this.getTitle(type)}</p>
          <p style="font-size: 0.875rem; color: var(--gray-600);">${message}</p>
        </div>
        <button onclick="this.parentElement.parentElement.remove()" style="background: none; border: none; cursor: pointer; color: var(--gray-400);">
          ✕
        </button>
      </div>
    `;

    this.container.appendChild(toast);

    // Auto-remove después del duration
    setTimeout(() => {
      toast.style.animation = 'slideOut 0.3s ease forwards';
      setTimeout(() => toast.remove(), 300);
    }, duration);
  }

  /**
   * Toast de éxito
   */
  success(message, duration) {
    this.show(message, 'success', duration);
  }

  /**
   * Toast de error
   */
  error(message, duration) {
    this.show(message, 'error', duration);
  }

  /**
   * Toast de advertencia
   */
  warning(message, duration) {
    this.show(message, 'warning', duration);
  }

  /**
   * Toast de información
   */
  info(message, duration) {
    this.show(message, 'info', duration);
  }

  /**
   * Obtener icono según tipo
   */
  getIcon(type) {
    const icons = {
      success: '✓',
      error: '✗',
      warning: '⚠',
      info: 'ℹ'
    };
    return `<span style="font-size: 1.5rem;">${icons[type] || icons.info}</span>`;
  }

  /**
   * Obtener título según tipo
   */
  getTitle(type) {
    const titles = {
      success: 'Éxito',
      error: 'Error',
      warning: 'Advertencia',
      info: 'Información'
    };
    return titles[type] || titles.info;
  }
}

// Agregar animación slideOut al CSS si no existe
const style = document.createElement('style');
style.textContent = `
  @keyframes slideOut {
    to {
      transform: translateX(100%);
      opacity: 0;
    }
  }
`;
document.head.appendChild(style);

export default new Toast();
